import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

import {MatTooltipModule} from '@angular/material/tooltip';
import {DxDataGridModule, DxPivotGridModule, DxTreeViewModule, DxListModule, DxContextMenuModule, DxTemplateModule, DxCheckBoxModule, DxSelectBoxModule, DxValidationSummaryModule, DxButtonModule, DxValidatorModule, DxBulletModule, DxLoadPanelModule, DxSortableModule} from 'devextreme-angular';
import {ComponentesModule} from '@componentes/Componentes.module';

import { GlobalModule } from '../global/global.module';
import { FormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { PipesModule } from '@pipes/Pipes.module';
import { EncuestaRoutingModule } from './encuesta-routing.module';
import { EncuestaComponent } from './general/general.component';
import { EncuestaDetalleComponent } from './general/general_detalle.component';

@NgModule({
    imports: [
        CommonModule,
        ComponentesModule,
        TranslateModule,
        FormsModule,
        MatTooltipModule,
        DxDataGridModule,
        DxCheckBoxModule,
        DxPivotGridModule,
        DxTreeViewModule,
        AngularSvgIconModule,
        PipesModule,
        GlobalModule,
        EncuestaRoutingModule,
    ],
    declarations: [
      EncuestaComponent,
      EncuestaDetalleComponent,
    ],
    entryComponents: [
      EncuestaDetalleComponent,
    ]
})
export class EncuestaModule {}
